import { Router } from './router/router';
import { Provider } from 'react-redux';
import './App.css';
import configureStore from './store/configureStore';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  BrowserRouter,
  Routes,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { Chart, registerables } from 'chart.js';
import * as Sentry from '@sentry/react';
import moment from 'moment';
import 'moment/locale/fr';
import { useEffect } from 'react';
moment.locale('fr');

Sentry.init({
  dsn: 'https://4a31111bd4142d9f16213b80dd77af31@o4505629562503168.ingest.sentry.io/4505629582753792',
  environment: process.env.NODE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      ),
    }),
  ],
  tracesSampleRate: 1.0,
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export default () => {
  const store = configureStore;
  const queryClient = new QueryClient();

  Chart.register(...registerables);

  // if (process.env.NODE_ENV === 'production') {
  //   console.log = () => null;
  //   console.error = () => null;
  //   console.debug = () => null;
  // }

  return (
    <QueryClientProvider client={queryClient}>
      <Provider {...{ store }}>
        <BrowserRouter basename='/portal'>
          <Router />
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
};
